<template>
  <section id="news" class="py-16 bg-gascon-gray">
    <div class="container mx-auto px-4">
      <h2 class="section-title text-gascon-blue">Dans le gras du sujet</h2>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        <div
          v-for="(item, index) in displayNews"
          :key="item.id || index"
          class="text-center"
        >
          <!-- Number badge -->
          <div class="inline-flex items-center justify-center w-12 h-12 border-b-2 border-gascon-gold text-gascon-gold font-bold text-lg mb-6">
            {{ String(index + 1).padStart(2, '0') }}
          </div>

          <!-- Title -->
          <h3 class="text-xl font-bold text-gascon-blue mb-4">
            {{ item.title }}
          </h3>

          <!-- Content -->
          <p class="text-gascon-blue/80 leading-relaxed text-justify">
            {{ item.content }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NewsSection',
  props: {
    news: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    displayNews() {
      // Show the 3 most recent news, or placeholder if none
      if (this.news.length > 0) {
        return this.news.slice(0, 3)
      }
      // Placeholder content matching the mockup
      return [
        {
          id: 1,
          title: 'Produits sélectionnés avec passion',
          content: 'Fournisseur de confiance pour brasseries, restaurants et chefs exigeants. Viandes, volailles, charcuteries et produits espagnols et italiens, crèmerie et burrata.'
        },
        {
          id: 2,
          title: 'En Gironde',
          content: 'Commandez en toute liberté, nous livrons directement à votre établissement, quelle que soit la quantité.'
        },
        {
          id: 3,
          title: 'Un service pensé pour les professionnels',
          content: 'Vous êtes chef, restaurateur ou gérant de brasserie ? Gagnez du temps et assurez la qualité dans vos cuisines avec notre sélection de produits choisis.'
        }
      ]
    }
  }
}
</script>
